import { createContext } from 'react';

import { ResidentsChangeLogState } from 'features/residents/resident-change-logs/providers/states/residents-change-log-state';

const ResidentsChangeLogProviderContext = createContext({} as ResidentsChangeLogState);

export default ResidentsChangeLogProviderContext;
